export default {
  state() {
    return {
      _lastSelectedContract: undefined
    }
  },
  getters: {
    get(state) {
      return state
    }
  },
  mutations: {
    set(state, { _lastSelectedContract }) {
      if (_lastSelectedContract) {
        state._lastSelectedContract = _lastSelectedContract
      }
    },
    clear(state) {
      const cleanState = {}
      Object.keys(state).forEach(key => {
        cleanState[key] = undefined
      })
      state = cleanState
    }
  },
  actions: {
    set({commit}, payload) {
      commit('set', payload)
    }
  }
}
